import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicCurrencyPipe } from './pipes/dynamic-currency.pipe';
import { SubscriptionTermsDaysFrequencyPipe } from './pipes/subscription-terms-days-frequency.pipe';

@NgModule({
  declarations: [DynamicCurrencyPipe, SubscriptionTermsDaysFrequencyPipe],
  exports: [DynamicCurrencyPipe, SubscriptionTermsDaysFrequencyPipe],
  imports: [CommonModule],
  providers: [DynamicCurrencyPipe, SubscriptionTermsDaysFrequencyPipe] 
})
export class SharedModule {}